import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://eba7044d412d97146ad4f80af2aeee94@o4508913972084736.ingest.de.sentry.io/4508913974640720',
    integrations: [],
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV,
    beforeSend: (event, hint) => {
      // Filter out network errors
      if (hint && hint.originalException) {
        const error = hint.originalException as any;
        if (
          error?.message?.includes('Network') ||
          error?.message?.includes('Failed to fetch')
        ) {
          return null;
        }
      }
      return event;
    },
  });
};
